import React from 'react';
import ReactDOM from 'react-dom/client';

import App from './App';
import './index.css';

import * as serviceWorkerRegistration from './serviceWorkerRegistration';
import reportWebVitals from './reportWebVitals';

function renderApp(newVersion: boolean, onUpdate: () => void) {
  const root = ReactDOM.createRoot(document.getElementById('root')!);
  root.render(<App newVersionAvailable={newVersion} onUpdateVersion={onUpdate} />);
}

renderApp(false, () => {});

// const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);

// root.render(<App />);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();

const configuration = {
  onUpdate: (registration: any) => {
    if (registration && registration.waiting) {
      // if (window.confirm('New version available!  refresh to update your app?')) {}
      renderApp(true, () => {
        registration.waiting.postMessage({ type: 'SKIP_WAITING' });
        window.location.reload();
      });
    }
  },
};

// serviceWorkerRegistration.unregister();
serviceWorkerRegistration.register(configuration);
